(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('ValueMonthlyReportController', ValueMonthlyReportController);

	ValueMonthlyReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state', '$location', '$anchorScroll'];

	function ValueMonthlyReportController($window, WineRepository, $log, lodash, $state, $location, $anchorScroll){

		/* jshint validthis: true */
		var self = this;

		self.valueByYearMonth = {};

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.report = {
			loading: true,
			groups: []
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.currentMonth = $window.moment().format('M');

		self.title = $state.current.data.title;

		self.jumpTo = jumpTo;

		self.print = print;

		self.initialize = initialize;

		/** initialize */
		initialize();

		/** begin methods */

		function initialize() {

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Month',
							'Value',
							'Change from last month'
						];

						/**
						 * determine all years and months.
						 * start at month.
						 * set total = 0
						 * loop through every wine and run wine.getValueAtDate(Year/month);
						 * take the results and add to the total.
						 * keep track of "last months" value and calculate percentage.
						 */

						var startDate = WineRepository.findFirstWineAcquisitionDate(wineEntities);

						var endOfMonth = startDate.endOf('month');

						var lastMonthsValue = 0;

						while(endOfMonth < $window.moment()) {
							endOfMonth.add(1, 'month').endOf('month');

							var year = endOfMonth.format('YYYY');
							var month = endOfMonth.format('M');
							var monthName = endOfMonth.format('MMMM');

							var total = 0;

							/* jshint loopfunc:true */
							// @todo can we do this faster?! Soo slow w/ many records.
							lodash.forEach(wineEntities, function(wine) {
								total += wine.getValueAtDate(endOfMonth);
							});
							/* jshint loopfunc:false */

							var valueDiff = total - lastMonthsValue;
							var percentDiff = valueDiff / total;

							lastMonthsValue = total;

							// create empty obj for year key
							if (typeof self.valueByYearMonth[year] === 'undefined') {
								self.valueByYearMonth[year] = {};
							}

							// create empty array for year.month
							self.valueByYearMonth[year][month] = {
								year: year,
								month: month,
								monthName: monthName,
								value: $window.numeral(total).format('$0,0[.]00'),
								valueDiff: $window.numeral(valueDiff).format('$0,0[.]00'),
								valueClass: getValueClass(valueDiff),
								percentDiff: $window.numeral(percentDiff).format('0[.]00%')
							};

							// if we are on the last month of the year we need to push the data onto self.report.group
							// this is what the frontend uses
							if (month === "12" || (year === self.currentYear && month === self.currentMonth)) {
								self.report.groups.push({
									year: year,
									months: self.valueByYearMonth[year]
								});
							}
						}

						// hide loading
						self.report.loading = false;

						return true;
					}

					return false;

				}).catch(function(err){
				$log.debug('Error getting wines', err);
			});
		}

		function getValueClass(amount) {
			var valueClass = 'report-value-';

			if (amount < 0) {
				valueClass += 'loss';
			} else if ( amount > 0) {
				valueClass += 'gain';
			} else {
				valueClass += 'nochange';
			}

			return valueClass;
		}

		function jumpTo(id) {
			$location.hash('item-' + id);
			$anchorScroll();
		}

		function print(){
			return $window.print();
		}
	}

})();
